const routes = [
  {
    path: "/processMonitor", // 流程监控主页面
    name: "processMonitor",
    component: () => import("@src/modules/processMonitor/main"),
    redirect: "/processMonitor/index",
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: "index", // 流程监控列表界面
        name: "index",
        component: () =>
          import("@src/modules/processMonitor/view/Index"),
        meta: {
          requireAuth: true,
          routerAlive: true,
        },
      },
    ],
  },
];

export default routes;
